if (!customElements.get('wlsn-main-blog-nav-tabs')) {
  class WLSNMainBlogNavTabs extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        tabLink: 'js-main-blog-tab-link',
      };

      this.bindMethods = {
        onTabClick: this._onTabClick.bind(this),
      };
    }

    /**
     * Get DOM elements
     * @returns {object} - Object containing DOM element references
     */
    get elements() {
      return {
        tabLinks: this.querySelectorAll(`.${this.classes.tabLink}`),
      };
    }

    /**
     * Connected callback lifecycle method
     * @returns {void}
     */
    connectedCallback() {
      this.elements.tabLinks.forEach((tabLink) => {
        tabLink.addEventListener('click', this.bindMethods.onTabClick);
      });
    }

    /**
     * Disconnected callback lifecycle method
     * @returns {void}
     */
    disconnectedCallback() {
      this.elements.tabLinks.forEach((tabLink) => {
        tabLink.removeEventListener('click', this.bindMethods.onTabClick);
      });
    }

    /**
     * Handle tab click event
     * @param {Event} event - The click event
     * @returns {void}
     */
    _onTabClick(event) {
      event.preventDefault();
      const currentTabLink = event.currentTarget;
      if (currentTabLink.classList.contains(this.classes.active)) return;

      const url = new URL(currentTabLink.href);

      window.WLSNHelpers.triggerEvent(this, 'wlsn:main-blog-nav-tabs:tab-clicked', { url: url.toString() });
    }
  }

  customElements.define('wlsn-main-blog-nav-tabs', WLSNMainBlogNavTabs);
}
